import { render, staticRenderFns } from "./BaseTextArea.vue?vue&type=template&id=4878eba3&scoped=true&"
import script from "./BaseTextArea.vue?vue&type=script&lang=js&"
export * from "./BaseTextArea.vue?vue&type=script&lang=js&"
import style0 from "./BaseTextArea.vue?vue&type=style&index=0&id=4878eba3&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4878eba3",
  null
  
)

export default component.exports